module.exports = __webpack_public_path__ + "static/media/landing-image.a6111aea.png";